import React from 'react';
import { createUseStyles } from 'react-jss';
import { Lottie } from '../Lottie';
import animationData from '@app/illu/Lottie/Loader.json';

const useStyles = createUseStyles(() => ({
  container: {
    marginBottom: -30,
    marginTop: -30,
  },
}));

export const Loader = () => {
  const classes = useStyles();

  return (
    <div className={classes.container}>
      <Lottie
        animationData={animationData}
        play
        loop
        style={{
          width: 200,
          height: 200,
        }}
      />
    </div>
  );
};
